import { render, staticRenderFns } from "./InnerForm.vue?vue&type=template&id=72ce7b91&"
import script from "./InnerForm.vue?vue&type=script&lang=js&"
export * from "./InnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports